export {
  abortActiveTransition,
  acquireTransitionPin,
  isLowPowerDevice,
  prefersReducedMotion,
  readDurationToken,
  releaseTransitionPin,
  requestIdleCallback,
  startViewTransition,
  supportsViewTransitions,
  updateTransitionPin,
  viewTransition,
  viewTransitionsEligible,
  yieldToMainThread,
} from "@theme/view-transition-utilities";

export {
  ResizeNotifier,
  TextComponent,
  calculateHeaderGroupHeight,
  center,
  changeMetaThemeColor,
  clamp,
  closest,
  debounce,
  fetchConfig,
  formatCountTranslation,
  getSearchSubmissionTerm,
  getIOSVersion,
  getViewParameterValue,
  getVisibleElements,
  isClickedOutside,
  isDesktopBreakpoint,
  isMobileBreakpoint,
  isPointWithinElement,
  isTouchDevice,
  mediaQueryLarge,
  normalizeString,
  onAnimationEnd,
  onDocumentLoaded,
  onDocumentReady,
  oncePerEditorSession,
  parseIntOrDefault,
  preloadImage,
  preventDefault,
  removeWillChangeOnAnimationEnd,
  resetShimmer,
  scheduler,
  setHeaderMenuStyle,
  start,
  throttle,
  updateAllHeaderCustomProperties,
} from "@theme/general-utilities";
